"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientContext = exports.ClientContext = void 0;
const makeContextAndHook_1 = require("../utils/makeContextAndHook");
/**
 * @internal
 */
_a = (0, makeContextAndHook_1.makeContextAndHook)('ClientContext'), exports.ClientContext = _a[0], exports.useClientContext = _a[1];
//# sourceMappingURL=ClientContext.js.map